import PerformanceMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/PerformanceMetricsIcon.vue'
import EngagementMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/EngagementMetricsIcon.vue'
import MediaMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/MediaMetricsIcon.vue'
import ConversionMetricsIcon from '../../../components/globals/Icons/LensIcons/filters/ConversionMetricsIcon.vue'

import store from '../../../store'
import getFilterTypeOperations from './filterTypeOperations'

const getMetricInputPlaceholder = (type) => {
  switch (type) {
    case 'number': return 'Value'
    case 'currency': return 'Amount'
    case 'percent': return 'Rate'
    default: return 'Value'
  }
}

const getMetricOptions = (parentGroup) => {
  const metrics = store.getters['MetricsModule/getMetrics']
  const groupMetrics = [
    ...metrics?.[parentGroup]?.metrics,
    ...(metrics?.[parentGroup]?.subSections?.flatMap(subSection => subSection.metrics) || []),
    ...(Array.isArray(metrics?.[parentGroup]?.tableSections) 
      ? metrics?.[parentGroup]?.tableSections?.flatMap(tableSection =>
          tableSection.metrics?.flatMap(row => row.metrics || []) || []
        ) || []
      : []
    )
  ]
  if (!groupMetrics) return []

  return groupMetrics.map(metric => ({
    optionType: 'metric',
    name: metric.name,
    key: metric.key,
    validOperations: getFilterTypeOperations(metric.type),
    input: { type: metric.type, placeholder: getMetricInputPlaceholder(metric.type) }
  })).filter(metric => metric.key !== 'percent_of_purchase_value' && metric.key !== 'percent_of_spend')
}

export default function dynamicFilterOptions() {

  const filterCategories = [
    {
      categoryName: 'Performance Metrics',
      icon: PerformanceMetricsIcon,
      options: getMetricOptions('performance')
    },
    {
      categoryName: 'Engagement Metrics',
      icon: EngagementMetricsIcon,
      options: getMetricOptions('engagement')
    },
    {
      categoryName: 'Media Metrics',
      icon: MediaMetricsIcon,
      options: getMetricOptions('media')
    },
    {
      categoryName: 'Conversion Metrics',
      icon: ConversionMetricsIcon,
      options: getMetricOptions('conversions')
    }
  ]

  return filterCategories
}